import RequestCheckQuery from "../../domain/core/request/RequestCheckQuery";
import { RequestCheckModel } from "../../domain/models/Request";
import { IQueryRequestCheckRepository } from "../../domain/ports/request/IQueryRequestCheckRepository";
import QueryService from "../QueryService";

export class RequestCheckQueryService
  extends QueryService<RequestCheckModel>
  implements IQueryRequestCheckRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const requestCheckQueryService = new RequestCheckQuery(
  new RequestCheckQueryService(BASE_URL, "request_checks"),
);

export { requestCheckQueryService };
